/* =========================================================================
   閲覧経路の記録（2026-10-01）
   訪問者がサイト内でたどったページと主な操作を localStorage に持ち、
   カート属性へ書き込む（注文の「追加の詳細」に表示される）。第三者へは送らない。
   「今すぐ購入」はカートを通らないため、商品フォームの隠し項目（_経路）にも同じ内容を入れる。
   ========================================================================= */
(function () {
  "use strict";
  var KEY = "fag_journey", FIRST = "fag_first", VISITS = "fag_visits", MAX = 60, GAP = 30 * 60 * 1000;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

  function get(k, d) { try { var v = JSON.parse(localStorage.getItem(k)); return v == null ? d : v; } catch (e) { return d; } }
  function set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function load() { var a = get(KEY, []); return Array.isArray(a) ? a : []; }
  function save(a) { set(KEY, a.slice(-MAX)); }
  function pad(n) { return (n < 10 ? "0" : "") + n; }
  function stamp(t) { var d = new Date(t); return (d.getMonth() + 1) + "/" + d.getDate() + " " + pad(d.getHours()) + ":" + pad(d.getMinutes()); }
  function clean(s, n) {
    s = String(s || "").replace(/\s+/g, " ").replace(/Unitree\s*[（(]ユニツリー[)）]\s*/g, "").trim();
    return s.length > n ? s.slice(0, n) + "…" : s;
  }
  function last(q, k) { var v = q.getAll(k); return v.length ? v[v.length - 1] : ""; }
  function refHost() { try { return document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, "") : ""; } catch (e) { return ""; } }

  /* 流入元。フィードの URL には無料リスティング用の UTM が先に付くので、UTM は最後の値を読む */
  function source() {
    var q = new URLSearchParams(location.search), host = refHost();
    var med = last(q, "utm_medium").toLowerCase(), camp = last(q, "utm_campaign"), src = last(q, "utm_source");
    var campLabel = camp && camp !== "sag_organic" ? "(" + clean(camp, 24) + ")" : "";
    if (q.get("gclid") || q.get("gbraid") || q.get("wbraid")) return "Google広告" + campLabel;
    if (q.get("ttclid")) return "TikTok広告" + campLabel;
    if (/^(cpc|ppc|paid|paidsocial)$/.test(med)) return (/facebook|instagram|meta/i.test(src) ? "Meta" : clean(src || "", 12)) + "広告" + campLabel;
    if (camp === "sag_organic") return "Google無料リスティング";
    if (src) return clean(src + (med ? "/" + med : ""), 30);
    if (!host || host === location.hostname.replace(/^www\./, "")) return "直接";
    if (/(^|\.)google\./.test(host)) return "Google検索";
    if (/yahoo\./.test(host)) return "Yahoo検索";
    if (/bing\.com$/.test(host)) return "Bing検索";
    if (/chatgpt\.com$|openai\.com$/.test(host)) return "ChatGPT";
    if (/instagram\.com$/.test(host)) return "Instagram";
    if (/facebook\.com$/.test(host)) return "Facebook";
    if (/(^|\.)(t\.co|x\.com|twitter\.com)$/.test(host)) return "X";
    if (/youtube\.com$|youtu\.be$/.test(host)) return "YouTube";
    if (/amazon\./.test(host)) return "Amazon";
    return clean(host, 30);
  }

  function act(label) { var a = load(); a.push({ t: Date.now(), k: "a", l: label }); save(a); }

  function summarize(limit) {
    var sessions = [], cur = null;
    load().forEach(function (x) {
      if (x.k === "s" || !cur) { cur = { t: x.t, src: x.k === "s" ? x.l : "不明", steps: [] }; sessions.push(cur); if (x.k === "s") return; }
      cur.steps.push(x.k === "p" ? (x.v ? "(" + x.v + ")" : "") + x.l : "[" + x.l + "]");
    });
    var first = get(FIRST, null), lastS = sessions[sessions.length - 1];
    var path = sessions.slice(-3).map(function (s) { return "〔" + stamp(s.t) + " " + s.src + "〕" + s.steps.join(" → "); }).join(" ｜ ");
    if (path.length > limit) path = "…" + path.slice(path.length - limit);
    return {
      visits: get(VISITS, sessions.length) || sessions.length,
      first: first ? stamp(first.t) + " " + first.l : "",
      last: lastS ? stamp(lastS.t) + " " + lastS.src : "",
      path: path
    };
  }

  function sync(keepalive) {
    var s = summarize(700);
    try {
      return fetch(ROOT + "cart/update.js", {
        method: "POST", keepalive: !!keepalive,
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ attributes: { "訪問回数": String(s.visits), "初回の流入": s.first, "今回の流入": s.last, "閲覧経路": s.path } })
      }).catch(function () {});
    } catch (e) {}
  }

  function fillProp() {
    var s = summarize(220);
    document.querySelectorAll("[data-journey-prop]").forEach(function (i) {
      i.value = "訪問" + s.visits + "回／初回 " + s.first + "／" + s.path;
      i.disabled = false;
    });
  }

  /* ---- このページの記録 ---- */
  var now = Date.now(), log = load(), prev = log[log.length - 1];
  var external = refHost() !== location.hostname.replace(/^www\./, "");
  var tagged = /[?&](gclid|gbraid|wbraid|fbclid|ttclid|utm_source)=/.test(location.search);
  if (!prev || now - prev.t > GAP || (tagged && external)) {
    var src = source();
    log.push({ t: now, k: "s", l: src });
    if (!get(FIRST, null)) set(FIRST, { t: now, l: src });
    set(VISITS, (get(VISITS, 0) || 0) + 1);
    prev = null;
  }
  var via = "";
  try { via = sessionStorage.getItem("fag_via") || ""; sessionStorage.removeItem("fag_via"); } catch (e) {}
  var page = clean(window.FAG_PAGE || document.title, 34);
  if (!(prev && prev.k === "p" && prev.l === page && now - prev.t < 5000)) log.push({ t: now, k: "p", l: page, v: via });
  save(log);
  fillProp();

  var drawer = document.getElementById("CartDrawer");
  if (drawer && parseInt(drawer.getAttribute("data-cart-count") || "0", 10) > 0) sync();

  if (window.clarity) {
    var sm = summarize(100);
    try { window.clarity("set", "流入", sm.last.replace(/^\S+ \S+ /, "")); window.clarity("set", "訪問回数", String(sm.visits)); } catch (e) {}
  }

  /* ---- 主な操作の記録 ---- */
  function zone(el) {
    if (el.closest("#CartDrawer, .cart-drawer")) return "カート";
    if (el.closest(".nav")) return "ナビ";
    if (el.closest(".hero")) return "ヒーロー";
    if (el.closest("footer")) return "フッター";
    return "本文";
  }
  function textOf(el) {
    var href = el.getAttribute("href") || "";
    if (/\/products\//.test(href) && !el.closest(".nav")) return "商品カード";
    return clean((el.getAttribute("data-track") || el.getAttribute("aria-label") || el.textContent || el.value || "").replace(/[→›»]/g, ""), 16);
  }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest(".pdp2__paybtn, .shopify-payment-button")) { act("今すぐ購入"); fillProp(); return; }
    var el = t.closest("a, button, summary, [role='button'], input[type='submit']");
    if (!el) return;
    if (el.matches("[data-qty-minus],[data-qty-plus],[data-line-plus],[data-line-minus],[data-cart-close],.pdp2__thumb")) return;
    if (el.matches(".nav-amazon")) { act("Amazonへ"); return; }
    if (el.matches("[data-atc]")) { var v = document.querySelector(".pdp2__swatch.is-on"); act("カートに追加" + (v ? ":" + clean(v.textContent, 22) : "")); return; }
    if (el.matches("[name='checkout']") || (el.tagName === "A" && /\/checkout/.test(el.getAttribute("href") || ""))) { act("レジへ進む"); sync(true); return; }
    if (el.matches("[data-cart-open]")) { act("カートを開く"); return; }
    if (el.matches("[data-line-remove]")) { act("カートから削除"); return; }
    if (el.matches(".pdp2__swatch")) { act("選択:" + clean(el.textContent, 22)); return; }
    if (el.tagName === "A") {
      var href = el.getAttribute("href") || "";
      if (el.hostname && el.hostname !== location.hostname) {
        var go = /\/go\/([a-z]+)/.exec(el.pathname || "");  // AD-Pilot の計測リンクは行き先名（amazon / youtube / instagram …）で記録
        act("外部:" + (el.hostname === "adpilot.ec-one.tech" && go ? go[1] : clean(el.hostname.replace(/^www\./, ""), 20)));
        return;
      }
      if (href && href.charAt(0) !== "#") { try { sessionStorage.setItem("fag_via", zone(el) + "「" + textOf(el) + "」"); } catch (err) {} return; }
    }
    var label = textOf(el);
    if (label) act(zone(el) + "「" + label + "」");
  }, true);

  window.FAGJourney = { sync: sync, act: act, summarize: summarize };
})();
